import { Resource } from 'ngx-jsonapi';

/**
 * Framework-agnostic `Rate` resource for the `systems` capability. Mirrors
 * the `attributes` of the legacy `@app/core/resources/rate.ts`, without
 * depending on it (see design.md Decision 2 of `systems-capability`).
 */
export class Rate extends Resource {
    public type: string = 'rates';
    public attributes: {
        system_id: string;
        conversion_price: number;
        base_price: number;
        total_price: number;
    } = {
        system_id: '',
        conversion_price: 0,
        base_price: 0,
        total_price: 0,
    };
}
